import cx from 'classnames';
import Link from 'next/link';
import { FiTrendingUp, FiTrendingDown } from 'react-icons/fi';
import { leagueData } from '@/data';
import type { StatsByRound } from '@/lib/query';
import { makeRoundUrl } from '@/lib/url';
import styles from './RoundInfo.module.css';
import { SongDisplay } from '@/components/SongDisplay';
import { DualVoteShare, VoteShare } from './VoteShare';

export const RoundInfo = ({
  round,
}: {
  round: StatsByRound[number];
}) => {
  return (
    <div className={styles.roundInfo}>
      <Link href={makeRoundUrl(leagueData.id, round.roundId)} target="_blank">
        <h3 className={styles.roundName}>
          [{round.roundNumber}] {round.roundName}
        </h3>
      </Link>

      <div className={styles.userSubmissions}>
        <h4>
          Your submissions
        </h4>
        <div className={styles.submissionList}>
          {round.userEntries.map((entry) => {
            return (
              <SongDisplay
                key={entry.id}
                entry={entry}
                showVotes
              />
            );
          })}
        </div>
      </div>

      <div className={styles.section}>
        <div>
          <h4>Score change</h4>
          <div className={styles.trend}>
            {round.scoreChange > 0 ? (
              <FiTrendingUp className={cx(styles.trendingIcon, styles.trendingIconUp)} />
            ) : (
              <FiTrendingDown className={cx(styles.trendingIcon, styles.trendingIconDown)} />
            )}
            {round.scoreChange}
          </div>
        </div>
        <div>
          <h4>Vote Spread</h4>
          <div className={styles.engagement}>
            {(100 * round.entriesVotedOnByUser / round.totalEntries).toFixed(2)}%
          </div>
        </div>
      </div>

      <div className={styles.voteStats}>
        <div>
          <h4>Vote share:</h4>
          <DualVoteShare
            upvotes={round.userUpvotes}
            downvotes={round.userDownvotes}
            totalVotes={round.totalVotes}
          />
        </div>
        <div>
          <h4>Upvote Share</h4>
          <div className={styles.voteStatsSubrow}>
            <div>
              <h5>Possible:</h5>
              <VoteShare
                votes={round.userUpvotes}
                totalVotes={round.upvotesForGrabs}
              />
            </div>
            <div>
              <h5>Round:</h5>
              <VoteShare
                votes={round.userUpvotes}
                totalVotes={round.totalUpvotes}
              />
            </div>
          </div>
        </div>
        <div>
          <h4>Downvote Share</h4>
          <div className={styles.voteStatsSubrow}>
            <div>
              <h5>Possible:</h5>
              <VoteShare
                votes={round.userDownvotes}
                totalVotes={round.downvotesForGrabs}
                type="downvote"
              />
            </div>
            <div>
              <h5>Round:</h5>
              <VoteShare
                votes={round.userDownvotes}
                totalVotes={round.totalDownvotes}
                type="downvote"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
